import { render, staticRenderFns } from "./NormalGOC.vue?vue&type=template&id=5d88ffa6&scoped=true&"
import script from "./NormalGOC.vue?vue&type=script&lang=js&"
export * from "./NormalGOC.vue?vue&type=script&lang=js&"
import style0 from "./NormalGOC.vue?vue&type=style&index=0&id=5d88ffa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d88ffa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d88ffa6')) {
      api.createRecord('5d88ffa6', component.options)
    } else {
      api.reload('5d88ffa6', component.options)
    }
    module.hot.accept("./NormalGOC.vue?vue&type=template&id=5d88ffa6&scoped=true&", function () {
      api.rerender('5d88ffa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/GOCComponents/NormalGOC.vue"
export default component.exports